export default __webpack_public_path__ + "static/media/53.c01f86ed.jpg";